import useController from "./useController"
import useStatic from "./useStatic"

export default function useApiController<T extends ObjectWithId = never>(resource: string): Hooks.UseApiController.Response<T> {
    const controller = useController(resource)

    const index = indexify<T>(controller)
    const store = (data?: any) => controller.post<T>(undefined, data)
    const show = (id: string | number) => controller.get<T>(id)
    const update = (id: string | number, data?: object) => controller.patch<T>(id, data)
    const destroy = (id: string | number) => controller.del(id)

    return useStatic({ ...controller, index, store, show, update, destroy })
}

/**
 * Adds function to index methods to manipulate data.
 */
function indexify<T extends ObjectWithId>(controller: ReturnType<typeof useController>): Hooks.UseApiController.Methods.Index<T> {
    const source = controller.get<T[]>()

    return {
        ...source,
        use: (cacheId?: string) => {
            const parent = source.use(cacheId)
    
            const removeById = (id: number) => {
                parent.setData((data: T[]) => data?.filter(item => item.id !== id))
            }

            const replace = (item: T) => {
                parent.setData((data: T[]) => data?.map(target => {
                    if (target.id === item.id)
                        return item

                    return target
                }))
            }
    
            return { ...parent, removeById, replace }
        }
    }
}